// extracted by mini-css-extract-plugin
export default {"title":"admin_title__y+qsw"};